<template>
  <component :style="getStyleObject()" :is="componentLoader('HtmlText')">
    <p slot="html" v-html="data.html.data"></p>
  </component>
</template>
<script>
  import settings from '@fremcast/section/mixins/section';
  import columnGrid from '@fremcast/section/mixins/columnGrid';
  export default {
    data() {
      return {
        cols: 's12'
      };
    },
    methods: {
      getStyleObject() {
        const style = this.fetchSettings.style;
        return {
          backgroundColor: style.backgroundColor,
          color: style.fontColor,
          "padding-left": style.paddingTop + 'px',
          "padding-top": style.paddingTop + 'px',
          "padding-right": style.paddingTop + 'px',
          "padding-bottom": style.paddingBottom + 'px'
        }
      }
    },
    props: [
      'data',
      'css'
    ],
    mixins: [
      settings,
      columnGrid
    ]
  }
</script>